import { makeSelectors } from '@utils/css';

const modifiers = makeSelectors({
  withStats: "_275wv16zyz",
  hasExpandedChild: "_275h1h9u6rc"
});

export { modifiers };
import "./table.root.style.linaria.module.css";
//# sourceMappingURL=table.root.style.js.map
